export enum TankLevelTransmitterTypeEnum {
    SinglePhase = 0,
    DualPhase = 1
}